import React, { useState, FormEvent } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../styles/AuthCommon.css";
import "../styles/ElegantLogin.css";
// import "./IOSSafariOptimized.css";
import InputFieldEnhanced from "../../../shared/components/ui/forms/InputFieldEnhanced";
import PrimaryButton from "../../../shared/components/ui/buttons/PrimaryButton";
import { Heart, Mail, Lock } from "lucide-react";
import { getBaseUrl } from "../../../config/urls";

/**
 * ログインページコンポーネント
 */
export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const urlBase = getBaseUrl();
  const urlLogin = urlBase + "/api/auth/login";

  console.log(`API実行URL: ${urlLogin}`);

  const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePassword = (password: string) => {
    const lengthCheck = password.length >= 8;
    const numberCheck = /[0-9]/.test(password);
    const lowerCheck = /[a-z]/.test(password);
    const upperCheck = /[A-Z]/.test(password);

    return lengthCheck && numberCheck && lowerCheck && upperCheck;
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setMessage(urlLogin)

    if (!email) return setMessage("メールアドレスを入力してください。");
    if (!validateEmail(email)) return setMessage("正しいメールアドレスを入力してください。");
    if (!password) return setMessage("パスワードを入力してください。");
    if (!validatePassword(password)) return setMessage("パスワードは8文字以上で、数字・小文字・大文字を含めてください。");

    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(urlLogin, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        if (res.status === 401) {
          setMessage("メールアドレスまたはパスワードが正しくありません。");
        } else if (res.status === 423) {
          setMessage("アカウントがロックされています。管理者にお問い合わせください。");
        } else {
          setMessage((data as any).message || "ログインに失敗しました。");
        }
        setLoading(false);
        return;
      }

      localStorage.setItem("token", (data as any).token);
      navigate("/admin/room-create");
    } catch (err) {
      console.error("Login error:", err);
      setMessage("サーバーに接続できません。しばらくしてから再度お試しください。");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="elegant-login-container">
      <div className="elegant-login-background">
      </div>
      
      <form onSubmit={handleSubmit} className="elegant-login-card">
        {/* ヘッダー装飾 */}
        <div className="elegant-login-header">
          <div className="header-decoration">
          </div>
          <h1 className="elegant-login-title">
            Photo Memorial
          </h1>
          <p className="elegant-login-subtitle">Wedding Memory Management</p>
        </div>

        {/* ログインフォーム */}
        <div className="elegant-form-section">
          <h2 className="elegant-form-title">ログイン</h2>
          
          <div className="elegant-input-group">
            <div className="input-icon">
              <Mail size={20} />
            </div>
            <InputFieldEnhanced
              type="email"
              id="email-input"
              name="email"
              placeholder="メールアドレス"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="elegant-input"
              autoComplete="email"
              inputMode="email"
              enterKeyHint="next"
            />
          </div>

          <div className="elegant-input-group">
            <div className="input-icon">
              <Lock size={20} />
            </div>
            <InputFieldEnhanced
              type={showPassword ? "text" : "password"}
              id="password-input"
              name="password"
              placeholder="パスワード（8文字以上・数字・小文字・大文字）"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="elegant-input"
              autoComplete="current-password"
              inputMode="text"
              enterKeyHint="done"
            />
          </div>

          <div className="elegant-checkbox-group">
            <label className="elegant-checkbox-label">
              <input
                type="checkbox"
                checked={showPassword}
                onChange={() => setShowPassword(!showPassword)}
                className="elegant-checkbox"
              />
              <span className="checkbox-text">パスワードを表示</span>
            </label>
          </div>

          <PrimaryButton type="submit" disabled={loading} className="elegant-login-button">
            {loading ? (
              "ログイン中..."
            ) : (
              <>
                <Heart size={20} />
                ログイン
              </>
            )}
          </PrimaryButton>

          {message && (
            <div className="elegant-message">
              <p>{message}</p>
            </div>
          )}

          <div className="elegant-links">
            <Link to="/auth/forgotPassword" className="elegant-link">
              <span>パスワードを忘れた場合</span>
            </Link>
          </div>
        </div>

        {/* フッター装飾 */}
        <div className="elegant-login-footer">
          <div className="footer-decoration">
            <div className="decoration-line"></div>
            <Heart className="footer-heart" />
            <div className="decoration-line"></div>
          </div>
          <p className="footer-text">Elegant Login for Special Moments</p>
        </div>
      </form>
    </div>
  );
}
